<template>
  <div class="flash-messages__container" v-if="messages.length">
    <transition-group name="fade">
      <template v-for="(message, index) in messages">
        <FlashMessage :key="index" :message="message"></FlashMessage>
      </template>
    </transition-group>
  </div>
</template>

<script>
  import FlashMessage from './FlashMessage.vue';

  export default {
    components: {
      FlashMessage,
    },
    props: ['messages'],
  }
</script>
